import * as React from 'react'

const SvgDragVerticalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 12.5h6.875v3.856l-1.619-1.612-.881.881L10 18.75l3.125-3.125-.881-.881-1.619 1.612V12.5H17.5v-1.25h-15v1.25zm4.375-8.125l.881.881 1.619-1.612V7.5H2.5v1.25h15V7.5h-6.875V3.644l1.619 1.612.881-.881L10 1.25 6.875 4.375z"
      fill="#163250"
    />
  </svg>
)

export default SvgDragVerticalIcon
